import { Banner } from '@braze/web-sdk';
import React, { useRef, useState } from 'react';
import { BrandColor } from '@styleseat/brand';
import { Box } from '@styleseat/ui';
import {
  Image,
  Pressable,
  View,
} from 'react-native';

export type BrazeBannerContentCardProps = {
  card: Banner;
  width?: number;
  height?: number;
  onClick?: () => void;
};

export const BrazeBannerCard: React.FCWithChildren<BrazeBannerContentCardProps> = ({
  card,
  width,
  height,
  onClick,
}) => {
  const [cardHeight, setCardHeight] = useState(0);
  const ref: React.Ref<View> = useRef<View>(null);
  const { imageUrl } = card;

  const getContainerSize = () => {
    const current = ref.current as any;
    const h = current?.offsetHeight || current?.parentNode?.offsetHeight;
    const w = current?.offsetWidth || current?.parentNode?.offsetWidth;
    return { height: h, width: w };
  };

  const handleLayoutChange = () => {
    if (height || width || !imageUrl) return;
    Image.getSize(imageUrl, (imageWidth, imageHeight) => {
      const { height: parentHeight, width: parentWidth } = getContainerSize();
      const ratio = parentWidth / imageWidth;
      // the image is wider than the container
      if (ratio < 1) {
        let nh = imageHeight * ratio;
        if (parentHeight > 0) {
          nh = Math.min(imageHeight * ratio, parentHeight);
        }
        setCardHeight(nh);
      } else {
        setCardHeight(imageHeight);
      }
    });
  };

  return (
    <Pressable
      onPress={onClick}
      style={{ width: '100%' }}
      ref={ref}
      onLayout={handleLayoutChange}
    >
      <Box
        color={BrandColor.WhiteWash}
        testID="content-card-banner"
        width="100%"
        height={height || cardHeight}
        paddingX={16}
      >
        <Image
          source={imageUrl}
          style={{
            flex: 1,
          }}
          resizeMode="contain"
        />
      </Box>
    </Pressable>
  );
};
